<div
  class="container flex flex-row lt-md:flex-col justify-between items-start lt-md:justify-start lt-md:items-center"
  [class.active-session]="connectionStatus === diagnosticsConnectionStatus.ACTIVE"
  [class.loading-session]="connectionStatus === diagnosticsConnectionStatus.LOADING"
  [class.failed-session]="connectionStatus === diagnosticsConnectionStatus.FAILED"
>
  <div
    class="flex flex-col gap-[20px] justify-start items-start lt-md:order-2 flex-[100%] lt-md:flex-1"
  >
    <ng-container
      *ngIf="
        connectionStatus === diagnosticsConnectionStatus.INACTIVE &&
          (remoteDiagnosticsStore.hasRestrictedAccessToActiveDiagnosticsSession(gatewaySerial)
            | async);
        else hasAccessToActiveDiagnosticsSession
      "
    >
      <h2>
        {{
          '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.CONNECTION_BOX.SESSION_RUNNING.TITLE'
            | translate
        }}
      </h2>
      <vi-text>
        {{
          '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.CONNECTION_BOX.SESSION_RUNNING.DESCRIPTION'
            | translate
        }}
      </vi-text>
      <button mat-raised-button color="primary" disabled>
        {{
          '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.CONNECTION_BOX.SESSION_RUNNING.BUTTON'
            | translate
        }}
      </button>
    </ng-container>

    <ng-template #hasAccessToActiveDiagnosticsSession>
      <h2>
        {{ '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.CONNECTION_BOX.TITLE' | translate }}
      </h2>
      <vi-text>
        {{
          '+INSTALLATIONS.INSTALLATION.DIAGNOSTICS_OVERLAY.CONNECTION_BOX.DESCRIPTION' | translate
        }}
      </vi-text>

      <button
        data-at-connect-to-diagnostic
        *ngIf="connectionStatus === diagnosticsConnectionStatus.INACTIVE"
        mat-raised-button
        color="primary"
        (click)="openDiagnosticsConnectionModal()"
        gtm="onOpen"
        gtmAction="Diagnostics overlay"
        gtmCategory="diagnosticsOverlay"
        [disabled]="isSelectedGatewayACascadeAndDeviceNotSelected"
        [class.highlight-connection-button]="highlightConnectionButton"
      >
        {{ 'DIAGNOSTIC.ACTIVE_SESSION.CONNECT' | translate }}
        <mat-icon iconPositionEnd>arrow_forward</mat-icon>
      </button>

      <button
        *ngIf="connectionStatus === diagnosticsConnectionStatus.LOADING"
        data-at-connection-progress
        mat-raised-button
        color="primary"
        class="loading-btn"
        disabled
      >
        {{ connectionProcessInPercent }}
        {{ 'DIAGNOSTIC.ACTIVE_SESSION.LOADED' | translate }}
        <mat-spinner iconPositionEnd></mat-spinner>
      </button>

      <button
        *ngIf="connectionStatus === diagnosticsConnectionStatus.FAILED"
        (click)="openDiagnosticsConnectionModal()"
        data-at-reconnect-try-again-button
        mat-raised-button
        color="primary"
        gtm="onTryAgain"
        gtmAction="Reconnect remote diagnostics"
        gtmCategory="diagnosticsOverlay"
        [attr.disabled]="isSelectedGatewayACascadeAndDeviceNotSelected"
      >
        <span>{{ 'GENERAL.BUTTON.TRY_AGAIN' | translate }}</span>
        <mat-icon iconPositionEnd>arrow_forward</mat-icon>
      </button>
    </ng-template>
  </div>
  <img class="lt-md:order-1" src="./assets/img/diagnostic_installer_guy.svg" />
</div>
